import { REQUIRED_FEATURE_FLAGS } from 'helpers/sf_constants';
import { useMemo } from 'react'
import { useSelector } from 'react-redux';
import useFeatureFlagsForAccounts from './useFeatureFlagsForAccounts';

const useClientV3Stats = () => {
    const [isFeatureFlagActiveForAccounts] = useFeatureFlagsForAccounts();

    const { current_account } = useSelector(state => ({
        current_account: state.accounts.current_account,
    }));

    const use_v3_api_for_campaign_stats = useMemo(() => {
        if (!current_account) return false
        return !current_account.internal && isFeatureFlagActiveForAccounts(
            REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USE_V3_API_FOR_CAMPAIGN_STATS,
            current_account
        )
    }, [isFeatureFlagActiveForAccounts, current_account]);

    const use_v3_api_for_campaign_conversion_stats = useMemo(() => {
        if (!current_account) return false
        return !current_account.internal && isFeatureFlagActiveForAccounts(
            REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USE_V3_API_FOR_CAMPAIGN_CONVERSION_STATS,
            current_account
        )
    }, [isFeatureFlagActiveForAccounts, current_account]);

    const use_dashboard_v3_api = useMemo(() => {
        if (!current_account) return false
        return !current_account.internal && isFeatureFlagActiveForAccounts(
            REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USE_DASHBOARD_V3_API,
            current_account
        )
    }, [isFeatureFlagActiveForAccounts, current_account]);

    const use_dashboard_conversions_v3_api = useMemo(() => {
        if (!current_account) return false
        return !current_account.internal && isFeatureFlagActiveForAccounts(
            REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USE_DASHBOARD_CONVERSIONS_V3_API,
            current_account
        )
    }, [isFeatureFlagActiveForAccounts, current_account]);

    const use_v3_api_for_ad_stats = useMemo(() => {
        if (!current_account) return false
        return !current_account.internal && isFeatureFlagActiveForAccounts(
            REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_USE_V3_API_FOR_AD_STATS,
            current_account
        )
    }, [isFeatureFlagActiveForAccounts, current_account]);

    return {
        use_v3_api_for_campaign_stats,
        use_dashboard_v3_api,
        use_v3_api_for_ad_stats,
        use_v3_api_for_campaign_conversion_stats,
        use_dashboard_conversions_v3_api
    }
};

export default useClientV3Stats;